import React, {Fragment} from 'react'
import useStateObject from 'admin/hooks/useStateObject'
import useAdmin from 'admin/hooks/useAdmin'
import useEffect from 'admin/hooks/useEffect'
import InputField from 'admin/components/shared/InputField'
import Modal from 'admin/components/shared/Modal'
import Header from '../shared/Header'

export default ({email, errors = {}, onSend, onDone, children}) => {
  const {admin} = useAdmin()
  const [form, setForm, resetForm] = useStateObject(email)
  const adminCc = form.cc && form.cc.includes(admin.email)
  const adminBcc = form.bcc && form.bcc.includes(admin.email)

  useEffect(() => resetForm(email), [email])

  const handleAddAdminCc = e => {
    e.preventDefault()
    let value = [form.cc, admin.email].filter(t => t).join(', ')
    setForm({cc: value})
  }

  const handleRemoveAdminCc = e => {
    e.preventDefault()
    let value = form.cc.replace(new RegExp(',? *' + admin.email), '')
    setForm({cc: value})
  }

  const handleAddAdminBcc = e => {
    e.preventDefault()
    let value = [form.bcc, admin.email].filter(t => t).join(', ')
    setForm({bcc: value})
  }

  const handleRemoveAdminBcc = e => {
    e.preventDefault()
    let value = form.bcc.replace(new RegExp(',? *' + admin.email), '')
    setForm({bcc: value})
  }

  const handleDone = e => {
    e.preventDefault()
    onDone && onDone(form)
    resetForm(email)
  }

  const handleSend = e => {
    e.preventDefault()
    onSend(form)
  }

  return (
    <Modal onClose={handleDone} flashId='edit-email'>
      <Header title='Edit email message' subtitle={children}>
        {onSend ? (
          <Fragment>
            <button className='button is-text is-decorationless' onClick={handleDone}>
              Cancel
            </button>
            <button className='button is-primary' onClick={handleSend}>
              Send
            </button>
          </Fragment>
        ) : (
          <button className='button' onClick={handleDone}>
            Done
          </button>
        )}
      </Header>
      <section className='section'>
        <form>
          <div className='field'>
            <div className='control'>
              <InputField
                type='text'
                name='to'
                errors={errors.to}
                value={form.to || ''}
                onChange={setForm}
                help='Separate multiple email addresses with a comma (,).'
              />
            </div>
          </div>
          <div className='field'>
            <div className='control'>
              <a
                href=''
                onClick={adminCc ? handleRemoveAdminCc : handleAddAdminCc}
                className='is-pulled-right is-size-7'>
                {adminCc ? "Don't cc" : 'Cc'} me
              </a>
              <InputField type='text' name='cc' errors={errors.cc} value={form.cc || ''} onChange={setForm} />
            </div>
          </div>
          <div className='field'>
            <div className='control'>
              <a
                href=''
                onClick={adminBcc ? handleRemoveAdminBcc : handleAddAdminBcc}
                className='is-pulled-right is-size-7'>
                {adminBcc ? "Don't bcc" : 'Bcc'} me
              </a>
              <InputField type='text' name='bcc' errors={errors.bcc} value={form.bcc || ''} onChange={setForm} />
            </div>
          </div>
          <div className='field is-spaced'>
            <div className='control'>
              <InputField
                type='text'
                name='subject'
                errors={errors.subject}
                value={form.subject || ''}
                onChange={setForm}
              />
            </div>
          </div>
          <div className='field'>
            <div className='control'>
              <InputField
                type='textarea'
                name='message'
                rows={10}
                errors={errors.message}
                value={form.message || ''}
                onChange={setForm}
              />
            </div>
          </div>
        </form>
      </section>
    </Modal>
  )
}
